module.exports = "/static/fonts/OpenSans-ExtraBoldItalic.ttf";